import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TransitionPageComponent} from './transition-page.component';

@NgModule({
  declarations: [
    TransitionPageComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TransitionPageComponent
  ]
})
export class TransitionPageModule {
}
